<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <!-- Login card -->
    <div class="relative z-10 w-full max-w-md mx-4">
      <!-- Card -->
      <div class="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
        <h1 class="text-xl font-semibold text-gray-900 mb-1">התחברות</h1>
        <p class="text-gray-400 text-sm mb-8">הזן את פרטי ההתחברות שלך</p>

        <div class="space-y-5">
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-600" for="email">אימייל</label>
            <InputText
              id="email"
              v-model="email"
              type="email"
              dir="ltr"
              class="w-full"
              @keydown.enter="signIn"
            />
          </div>

          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-600" for="password">סיסמה</label>
            <InputText
              id="password"
              v-model="password"
              type="password"
              placeholder="••••••••"
              dir="ltr"
              class="w-full"
              @keydown.enter="signIn"
            />
          </div>
        </div>

        <!-- Error message -->
        <div v-if="errorMsg" class="mt-4 bg-red-50 border border-red-200 rounded-lg px-4 py-2.5 text-red-600 text-sm">
          {{ errorMsg }}
        </div>

        <Button
          class="w-full mt-8 !bg-gradient-to-r !from-purple-600 !to-indigo-600 hover:!from-purple-500 hover:!to-indigo-500 !text-white !font-semibold !py-3 !rounded-xl !border-0"
          :loading="loading"
          @click="signIn"
        >
          <span v-if="!loading">כניסה למערכת</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword';
import { PlatformRouteNames } from '../router/route-names';

const router = useRouter();
const email = ref('');
const password = ref('');
const loading = ref(false);
const errorMsg = ref('');

const signIn = async () => {
  if (!email.value || !password.value) {
    errorMsg.value = 'נא למלא את כל השדות';
    return;
  }

  loading.value = true;
  errorMsg.value = '';

  try {
    const response = await EmailPassword.signIn({
      formFields: [
        { id: 'email', value: email.value },
        { id: 'password', value: password.value },
      ],
    });

    if (response.status === 'WRONG_CREDENTIALS_ERROR' || response.status === 'FIELD_ERROR') {
      errorMsg.value = 'פרטי ההתחברות שגויים';
      loading.value = false;
      return;
    }

    // Test if user actually has admin access by hitting a platform endpoint
    try {
      const testUrl = `${import.meta.env.VITE_BACKEND_URL || ''}/platform/activity`;
      const testResponse = await fetch(testUrl, { method: 'get', headers: { 'content-type': 'application/json' } });
      if (testResponse.status === 403) {
        errorMsg.value = 'אין לך הרשאת גישה למערכת הניהול';
        loading.value = false;
        return;
      }
    } catch {
      // If the test fails for network reasons, let the user through — they'll be blocked by the API anyway
    }

    router.push({ name: PlatformRouteNames.Activity });
  } catch (e) {
    console.error(e);
    errorMsg.value = 'שגיאה בהתחברות, נסה שוב';
  } finally {
    loading.value = false;
  }
};
</script>
